import { render, staticRenderFns } from "./Page401.vue?vue&type=template&id=331e9e8a"
import script from "./Page401.vue?vue&type=script&lang=js"
export * from "./Page401.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports